<template>
  <div class="hello">
    <div class="title1">绑定手机号</div>
    <div class="title2">绑定后，微信可以接收设备报警推送</div>
    <div class="input-form">
      <div class="input-container">
        <img src="../../../static/wechat/iconPhone.png" />
        <input
          placeholder="请输入手机号"
          v-model="request.phone"
          maxlength="11"
        />
      </div>
      <div class="input-container">
        <img src="../../../static/wechat/iconCode.png" />
        <input
          placeholder="请输入验证码"
          v-model="request.code"
          maxlength="6"
        />
        <button class="btn-code" @click="getCode">{{ count }}</button>
      </div>
      <button class="btn-submit" @click="bindWeChat">立即绑定</button>
    </div>
  </div>
</template>
<script>
const TIME_COUNT = 60;

import { Toast, MessageBox } from "mint-ui";
export default {
  name: "ddbindPhone",
  data() {
    return {
      count: "获取验证码",
      timer: null,
      isShow: false,
      datacode: 0, //200：账号可以绑定，202：账号已经被其他微信绑定
      request: {
        phone: "",
        code: ""
      },
      bindRequest: {
        openId: "",
        phone: ""
      },
      user: {}
    };
  },
  mounted() {
    this.bindRequest.openId = this.$route.query.openId;
  },
  methods: {
    //调用接口查询要绑定的用户信息
    getUserInfo() {
      var _t = this;
      this.common.doActionGet(this.common.bindBefore, this.request, function(
        res
      ) {
        if (res.code == 200 || res.code == 202) {
          _t.datacode = res.code;
          _t.isShow = true;
          if (res.code == 202) {
            _t.user.username = res.data.nickname;
            _t.user.userlogo = res.data.headImgUrl;
          } else {
            _t.user.username = res.data.username;
            _t.user.userlogo = res.data.userlogo;
          }
        } else {
          MessageBox.alert(res.msg, "ERROR");
        }
      });
    }
  }
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";
.hello {
  height: 100%;
  padding: 0px 20px;
}
.title1 {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin-top: 60px;
}
.title2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-top: 10px;
}
.input-form {
  margin-top: 70px;
  height: 120px;
}
.input-container {
  height: 24px;
  padding-top: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e4e4;
  display: flex;
}
.input-container img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.input-container input {
  border: none;
  flex-grow: 1;
  height: 24px;
  line-height: 24px;
  min-width: 100px;
  font-size: 14px;
}
.btn-code {
  /* width: 100px; */
  height: 26px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 12px;
  flex: 0 0 80px;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/dd/ddwexinPay.vue